<template>
	<div>
		<!-- Popup -->
		<vs-popup
			:active.sync="showPopup"
			:title="'Commentaires N°Contrat ' + $props.contract_id"
		>
			<div class="note-form popup-content">
				<div v-if="isLoading">
					<circular-loader />
				</div>
				<div v-else>
					<label for="TaskComment">
						Besoin de dire quelque chose au service comptabilité à propos de
						cette tâche?
					</label>
					<vs-textarea class="w-full" v-model="taskComment"></vs-textarea>
					<div class="button-container">
						<vs-button
							ref="send-message-button"
							class="mt-5"
							@click="addTaskComment"
							:disabled="isblock"
						>
							Enregistrer
						</vs-button>
					</div>

					<!-- Blocking Overlay (Only inside popup) -->
					<div v-if="isblock" class="popup-overlay">
						<div class="flex flex-col">
							<div class="overlay-content">
								<p>⚠️ {{ blockMessageFirst }}</p>

								<p>
									<b>
										{{ blockMessageSecond }}
									</b>
								</p>
							</div>
							<div class="flex justify-end mt-5">
								<vs-button @click="onSendMessageClick()">
									Envoyer un message
								</vs-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>
  
    
    <script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import Task from "../../entities/Task";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import NotepadPopup from "./NotepadPopup.vue";
export default {
	created() {
		// store.dispatch("getAllSocieties");
		this.assginTaskComment();
		//getting orders which belongs to user sign in
	},
	components: { CircularLoader },
	mounted() {},
	name: "AddTaskCommentPopup",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		popupActive: Boolean,
		task: {
			type: Object,
			default: {},
		},
		contract_id: {
			type: Number,
			default: 0,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			thisTask: {},
			taskComment: "",
			showPopup: this.$props.popupActive,
			isLoading: true,
			isblock: false,
			showNotepadPopup: false,
			blockMessageFirst:
				"La facturation a déjà été finalisée pour cette prestation pour cette période. Vous ne pouvez donc pas laisser de commentaire !",
			blockMessageSecond:
				"Vous devez contacter Steve par messagerie à la place",
		};
	},
	computed: {
		allSocieties: () => {
			return store.state.societies;
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		assginTaskComment: async function () {
			try {
				this.isLoading = true;
				this.thisTask = await Task.getWithInvoice(this.$props.task.task_id);
				this.taskComment = this.thisTask.comment_facturation || "";
				if (this.thisTask.inovice.is_sent > 0) this.isblock = true;
				else this.isblock = false;
				this.isLoading = false;
			} catch (err) {
				console.log(err);
				this.isLoading = false;
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Erreur trove le taches",
				});
			}
		},

		addTaskComment: async function () {
			if (this.taskComment.trim() === "") return;
			this.setLoading(true, "send-message-button");
			// //console.log("COMEMRCIOA", this.destinationUserId);

			const body = {
				comment_facturation: this.taskComment,
			};

			await Task.update(body, this.$props.task.task_id)
				.then((res) => {
					this.$vs.notify({
						title: "Succès",
						color: "success",
						text: "Commentaire ajouté avec succès",
					});
					this.setLoading(false, "send-message-button");
					this.showPopup = false;
					let updatedTask = {
						...this.$props.task,
						task_comment_facturation: this.taskComment,
					};
					this.$emit("update-task-comment", updatedTask);
					// this.$emit("close-popup");
				})
				.catch((err) => {
					console.log(err);
					this.setLoading(false, "send-message-button");
					this.$vs.notify({
						title: "Echec",
						color: "danger",
						text: "Erreur lors de l'ajout du commentaire",
					});
				});
		},
		onSendMessageClick() {
			this.showPopup = false;
			this.displayNotePadPopup(this.$props.contract_id);
		},
		displayNotePadPopup(contract_id) {
			// Initialisation des données pour le popup
			this.showNotepadPopup = true;
			let userId = 14; // Steve user id
			// Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopup);

			let notepadPopup = new ComponentClass({
				propsData: {
					contract_id: contract_id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl || "",
					society_id: this.thisTask.contract_society_id,
					destinationUserId: Number(userId) || userId,
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},
	},
};
</script>
<style scoped>
.button-container {
	display: flex;
	justify-content: flex-end; /* Aligns button to the right */
	margin-top: 10px;
}
.popup-content {
	position: relative;
}

.popup-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.8); /* Light transparent background */
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10; /* Ensure it's above content inside popup */
}

.overlay-content {
	background: rgba(255, 255, 255, 0.8);
	padding: 20px;
	border-radius: 8px;
	text-align: center;
}
</style>
    